<template>
  <div class="slide" id="record-of-support" v-show="isVisibleSlide('record-of-support')">
    <div class="slide_inner two_col_wrap">
      <div class="left">&nbsp;</div>
      <div class="right">
        <h1>OFFICIAL RECORD OF SUPPORT FOR ASSISTED DYING - ADD YOUR NAME</h1>
        <p>Terminally ill people deserve the right to die on their own terms, but the UK's current law against assisted dying is forcing people to suffer unnecessarily.</p>
        <p>To end this injustice and get politicians to listen, we’re building the biggest ever public record of support for assisted dying.</p>
        <div class="progress_bar_wrap">
          <div class="progress_bar" :style="{width: $store.getters.getProgress + '%'}"></div>
        </div>
        <p class="progress_label">
          <strong>{{ $store.getters.getSignups }}</strong>
          people have already added their name. Will you help us reach {{ $store.getters.getTargetWithCommas }}?
        </p>
        <form class="action-form" @submit.prevent="submitForm">
          <div class="error" v-if="!validPostcode">Please enter a valid Postcode</div>
          <div class="input-group">
            <label for="email">
              First name
              <span class="pink">*</span>
            </label>
            <input
              type="text"
              name="firstname"
              id="firstname"
              v-model="form.firstname"
              v-validate="'required|min:1'"
            >
            <p
              v-if="errors.has('firstname')"
              class="validation-error"
              role="alert"
            >Please enter your first name</p>
          </div>
          <div class="input-group">
            <label for="email">
              Email Address
              <span class="pink">*</span>
            </label>
            <input
              type="text"
              name="email"
              id="email"
              v-model="form.email"
              v-validate="'required|min:1'"
            >
            <p
              v-if="errors.has('email')"
              class="validation-error"
              role="alert"
            >Please enter a valid Email</p>
          </div>
          <div class="input-group">
            <label for="email">
              Postcode
              <span class="pink">*</span>
            </label>
            <input
              type="text"
              name="postcode"
              id="postcode"
              v-model="form.postcode"
              v-validate="'required|min:1'"
            >
            <p
              v-if="errors.has('postcode')"
              class="validation-error"
              role="alert"
            >Please enter a valid Postcode</p>
          </div>
          <div class="input-group inline">
            <label
              for="optin"
              class="small"
            >We can only update you when there's a win in the campaign if you sign up to receive emails from us. So, are you happy to receive emails about the campaign?</label>
            <label class="radio">
              <input
                type="radio"
                name="optin"
                value="Y"
                id="optin-yes"
                v-model="form.optin"
                v-validate="'required'"
              >
              <span>Yes</span>
            </label>
            <label class="radio">
              <input
                type="radio"
                name="optin"
                value="N"
                id="optin-no"
                v-model="form.optin"
                v-validate="'required'"
              >
              <span>No</span>
            </label>
            <p v-if="form.optin == 'N'" class="small">
              <strong>Are you sure?</strong>
            </p>
            <p
              v-if="form.optin == 'N'"
              class="small"
            >If you select 'No', you won't receive any updates on what you can do to help legalise assisted dying. If you select 'Yes', you can still unsubscribe at any time.</p>
            <p
              v-if="errors.has('optin')"
              class="validation-error"
              role="alert"
            >Please select an opt in option</p>
          </div>
          <div class="input-group">
            <button type="submit" class="btn-submit">TAKE ACTION NOW!</button>
          </div>
          <p class="privacy-policy">
            We will never share your details with a third party and you can opt-out at any time. You can read our full privacy policy
            <a
              href="https://www.dignityindying.org.uk/privacy-policy/"
              target="_blank>"
            >here</a>.
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  name: "RecordOfSupport",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {
      form: {
        firstname: null,
        email: null,
        postcode: null,
        optin: null
      },
      mp: {
        name: "",
        constituency: "",
        priority: ""
      },
      validPostcode: true
    };
  },
  mounted() {
    window.form = this.form;
  },
  methods: {
    submitForm() {
      this.validPostcode = true;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          axios
            .get(
              "https://development.forwardaction.uk/did-mp-api/?postcode=" +
                this.form.postcode
            )
            .then(response => {
              console.log(response.data);
              const mp = response.data;
              this.mp.name = mp.title + " " + mp.firstName + " " + mp.lastName;
              this.mp.constituency = mp.organization;
              this.mp.priority = mp.priority;
              this.enAjax();
            })
            .catch(error => {
              if (error.response) {
                if (
                  error.response.data.error ==
                  "there was an error with your request or the service is not available."
                ) {
                  console.log("postcode not valid");
                  this.validPostcode = false;
                }
              } else {
                console.log(error);
              }
              return;
            });
        }
      });
    },
    enAjax() {
      const data = {
        hidden: "",
        "supporter.firstName": this.form.firstname,
        "supporter.emailAddress": this.form.email,
        "supporter.postcode": this.form.postcode,
        "supporter.questions.384955": this.form.optin, //optin
        "supporter.questions.402492": this.mp.priority, //priority
        "supporter.questions.408376": this.mp.constituency, //const
        "supporter.questions.408377": this.mp.name //name
      };

      const options = {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: qs.stringify(data),
        withCredentials: false,
        url: "https://action.dignityindying.org.uk/page/40548/petition/2"
      };

      axios(options)
        .then(response => {
          console.log(response);
          this.$store.commit("updateMP", this.mp);
          this.$store.commit("updateUser", this.form);
          this.analytics("record_of_support", "submitted");
          this.analytics("postcode_priority", this.mp.priority);
          // eslint-disable-next-line
          fbq("track", "CompleteRegistration");
          if (this.mp.priority == "Priority") {
            this.gotoSlide("thanks");
          } else {
            this.gotoSlide("will-share");
          }
        })
        .catch(error => {
          console.log(error);

          // just for testing offline
          // this.$store.commit("updateMP", this.mp);
          // this.$store.commit("updateUser", this.form);
          // this.analytics("record_of_support", "submitted");
          // this.analytics("postcode_priority", this.mp.priority);
          // if (this.mp.priority == "Priority") {
          //   this.gotoSlide("thanks");
          // } else {
          //   this.gotoSlide("will-share");
          // }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.slide {
  background-image: url("https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/did-bg3.jpg?v=1553617703000");
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0 30px;
  display: flex;
  justify-content: center;
  background-attachment: fixed;
  align-items: initial;
  @media (max-width: 767px) {
    padding: 0;
  }
}
.two_col_wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  .left {
    width: 100%;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .right {
    background: white;
    width: 100%;
    padding: 40px;
    @media (max-width: 767px) {
      padding: 25px;
    }
    p.small {
      font-size: 14px;
      margin: 0 0 8px;
    }
    .privacy-policy {
      margin-top: 10px !important;
      font-size: 12px;
      line-height: 1.5;
    }
    .progress_bar_wrap {
      height: 30px;
      border: 2px solid rgb(213, 27, 91);
      .progress_bar {
        height: 26px;
        background-color: rgb(213, 27, 91);
        width: 0%;
        transition: all 1s;
      }
    }
    .progress_label {
      font-family: "Interstate", "Helvetica Neue", Helvetica, Arial, sans-serif;
      line-height: 1.5;
    }
  }
}
.error {
  color: red;
}
</style>